<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="
              '/' + authUser.userable_type + '/investors/transaction-requests'
            "
            >Transaction Requests</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-4" style="display: flex">
        <date-range-picker
          ref="picker"
          :locale-data="{
            firstDay: 1,
            format: 'dd-mm-yyyy',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
          }"
          :timePicker="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="filter()"
          :linkedCalendars="true"
          style="width: 100%; background-color: #fafaf7 !important"
        >
        </date-range-picker>
        <button
          style="font-size: 12px; height: 35px; margin-left: 5px"
          type="button"
          class="btn btn-info"
          @click="clearDateRage()"
        >
          Clear
        </button>
      </span>

      <span class="col-4">
        <multiselect
          v-model="selected_investors"
          :options="investors"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Investors"
          label="code"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} investors selected</span
            ></template
          >
        </multiselect>
      </span>
      <span class="col-3">
        <multiselect
          v-model="selected_types"
          :options="transactionRequestTypes"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Types"
          label="name"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} types selected</span
            ></template
          >
        </multiselect></span
      >
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
        "
      >
        <spinner v-if="searchingTransactionRequests" />

        <vue-good-table
          v-else
          :columns="transactionRequestColumns"
          :rows="transactionRequests"
          max-height="450px"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'code', type: 'asc' },
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.label == 'Amount'">
              {{
                fixNumberView(props.row.amount) + " " + props.row.currency.code
              }}
            </span>
            <span
              v-else-if="props.column.label == 'ID'"
              @click="toggleTransactionRequestModal(props.row)"
              style="cursor: pointer; color: #8cc63f; font-weight: bold"
            >
              {{ props.row.code }}
            </span>
          </template></vue-good-table
        >
      </md-card>
    </div>
    <transaction-request-modal
      :active="showTransactionRequestModal"
      :activeTransactionRequest="activeTransactionRequest"
      @saveRequest="handleSave"
      @closeRequest="toggleTransactionRequestModal()"
    />
  </div>
</template>
<script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import moment from "moment";
import TransactionRequestsFilter from "../../filters/TransactionRequestsFilter";
import DateRangePicker from "vue2-daterange-picker";
import Spinner from "vue-simple-spinner";
import Multiselect from "vue-multiselect";
import TransactionRequestModal from "./components/modals/transactionRequestModal.vue";

export default {
  name: "investorTransactionRequests",
  data() {
    return {
      transactionRequestTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      transactionRequestColumns: [
        {
          label: "ID",
          field: "code",
        },
        {
          label: "Date",
          field: "date",
        },
        {
          label: "Investor ID",
          field: "investor_code",
        },
        {
          label: "Contract ID",
          field: "contract_code",
        },
        {
          label: "Type",
          field: this.transactionRequestType,
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Payment Type",
          field: this.transactionRequestPaymentType,
        },
        {
          label: "Status",
          field: this.transactionRequestStatus,
        },
      ],
      type: null,
      transactionRequest_id: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      selected_investors: null,
      selected_types: null,
      code: null,
      statusList: [
        { id: "pending-review", name: "Pending Review" },
        { id: "cancelled", name: "Cancelled" },
        { id: "completed", name: "Completed" },
      ],
      activeTransactionRequest: null,
      showTransactionRequestModal: false,
    };
  },

  components: {
    DateRangePicker,
    Spinner,
    Multiselect,
    TransactionRequestModal,
  },
  created: function () {
    var transactionRequestsFilter = TransactionRequestsFilter();
    transactionRequestsFilter.appends = [
      "investor_code",
      "contract_code",
      "plan",
      "paymentMethod",
    ];
    this.$store.dispatch("searchTransactionRequests", {
      filter: transactionRequestsFilter,
      resultMode: "default",
    });
  },

  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      transactionRequests: (state) =>
        state.transactionRequestStore.transactionRequestSearch
          .transactionRequests,
      investors: (state) => state.investorStore.investorSearch.investors,
      searchingTransactionRequests: (state) =>
        state.transactionRequestStore.transactionRequestSearch
          .searchingTransactionRequests,
      updateTransactionRequestStatus: (state) =>
        state.transactionRequestStore.transactionRequestUpdate
          .updateTransactionRequestStatus,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    init() {
      this.activeTransactionRequest = null;
      this.showTransactionRequestModal = false;
      var transactionRequestsFilter = TransactionRequestsFilter();
      transactionRequestsFilter.appends = [
        "investor_code",
        "contract_code",
        "plan",
        "paymentMethod",
      ];
      this.$store.dispatch("searchTransactionRequests", {
        filter: transactionRequestsFilter,
        resultMode: "default",
      });
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    transactionRequestType(transactionRequest) {
      return (
        transactionRequest.type.charAt(0).toUpperCase() +
        transactionRequest.type.slice(1)
      );
    },
    transactionRequestPaymentType(transactionRequest) {
      return (
        transactionRequest.payment_type.charAt(0).toUpperCase() +
        transactionRequest.payment_type.slice(1)
      );
    },
    toggleTransactionRequestModal(transactionRequest = null) {
      this.showTransactionRequestModal = !this.showTransactionRequestModal;
      this.activeTransactionRequest = transactionRequest;
    },
    transactionRequestStatus(transactionRequest) {
      return this.statusList.find((status) => {
        return status.id == transactionRequest.status;
      }).name;
    },
    filter() {
      // var transactionRequestsFilter = TransactionsFilter();
      // transactionRequestsFilter.code = this.code;
      // if (this.selected_investors) {
      //   this.selected_investors.forEach((investor) => {
      //     if (
      //       !transactionRequestsFilter.account_ids.includes(investor.account_id)
      //     ) {
      //       transactionRequestsFilter.account_ids.push(investor.account_id);
      //     }
      //   });
      // }
      // if (this.selected_types) {
      //   this.selected_types.forEach((type) => {
      //     if (!transactionRequestsFilter.types.includes(type.id)) {
      //       transactionRequestsFilter.types.push(type.id);
      //     }
      //   });
      // }
      // if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
      //   let start_date = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      //   let end_date = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      //   let date_range = { startDate: start_date, endDate: end_date };
      //   transactionRequestsFilter.dateRange = date_range;
      // }
      // transactionRequestsFilter.account_types = ["investor_account"];
      // this.$store.dispatch("searchTransactions", {
      //   filter: transactionRequestsFilter,
      //   resultMode: "default",
      // });
    },
    clearDateRage() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.filter();
    },
    handleSave(payload) {
      this.$store.dispatch("updateTransactionRequestStatus", payload);
    },
  },
  watch: {
    // createTransactionStatus() {
    //   if (this.createTransactionStatus == "success") {
    //     sweetAlert({
    //       title: "Success",
    //       text: "Transaction has been created successfully",
    //       icon: "success",
    //       confirmButtonText: "Done",
    //     }).then(() => {
    //       this.init();
    //     });
    //   } else if (this.createTransactionStatus == "failed") {
    //     sweetAlert({
    //       title: "Failed",
    //       text: "Transaction creation has failed",
    //       IntersectionObserver: "error",
    //       confirmButtonText: "Return",
    //     });
    //   }
    // },
    // updateTransactionStatus() {
    //   if (this.updateTransactionStatus == "success") {
    //     sweetAlert({
    //       title: "Success",
    //       text: "Transaction has been updated successfully",
    //       icon: "success",
    //       confirmButtonText: "Done",
    //     }).then(() => {
    //       this.init();
    //     });
    //   } else if (this.updateTransactionStatus == "failed") {
    //     sweetAlert({
    //       title: "Failed",
    //       text: "Transaction update has failed",
    //       IntersectionObserver: "error",
    //       confirmButtonText: "Return",
    //     });
    //   }
    // },
    // deleteTransactionStatus() {
    //   if (this.deleteTransactionStatus == "success") {
    //     sweetAlert({
    //       title: "Success",
    //       text: "Transaction has been deleted successfully",
    //       icon: "success",
    //       confirmButtonText: "Done",
    //     }).then(() => {
    //       this.init();
    //     });
    //   } else if (this.deleteTransactionStatus == "failed") {
    //     sweetAlert({
    //       title: "Failed",
    //       text: "Transaction delete has failed",
    //       IntersectionObserver: "error",
    //       confirmButtonText: "Return",
    //     });
    //   }
    // },
    updateTransactionRequestStatus() {
      if (this.updateTransactionRequestStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Transaction request status has been updated",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateTransactionRequestStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Transaction request status update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #00a5e3;
}
.multiselect__tags {
  background-color: #fafaf7;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 20px 0 8px;
  font-size: 16px;
}
.multiselect__input,
.multiselect__single {
  background: none;
  font-size: 14px;
  margin: 0;
  margin-top: 5px;
}
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.custom-select {
  background-color: #fafaf7;
}
.form-control {
  background: #fafaf7 !important;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 20px 0 8px !important;
  font-size: 16px;
  border: 1px solid #e8e8e8 !important;
}
.form-control:focus {
  background: #fafaf7 !important; /* Change this to the desired color when the input is focused */
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: center;
}
.vgt-right-align {
  text-align: center;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff;
}

table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #dbd5dc #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #dbd5dc;
  border-radius: 10px;
  border: 3px solid #ffffff;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/investorsTransactionRequests.vue